import { Button } from './Button'
import { UserProfileAdd } from 'blaze-ui/icons'
import { UserProfileAdd as UserProfileAdd24 } from 'blaze-ui/icons/24'
import { useModals } from 'almanac-ui/Modal'
import { ShareButtonProps } from './Types'
import { ShareSheetV2 } from 'common/ShareSheetV2/ShareSheetV2'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ShareSheetDrawer } from 'common/ShareSheetV2/Drawer/ShareSheetDrawer'
import { TopBarButton } from './TopBarButton'

export const ShareButton = observer(({ articleId }: ShareButtonProps) => {
  const { isMobile } = useResponsiveDesign()
  const { openModal: openShareModal } = useModals()
  const { drawersStore } = useRootStore()

  const handlePress = () => {
    if (isMobile) {
      drawersStore.openDrawer(ShareSheetDrawer, {
        file: {
          id: articleId,
          type: 'article',
        },
      })
      return
    }

    openShareModal(ShareSheetV2, {
      file: {
        id: articleId,
        type: 'article',
      },
    })
  }

  if (isMobile) {
    return <TopBarButton icon={UserProfileAdd24} onPress={handlePress} aria-label="Share for Review" />
  }

  return (
    <Button icon={UserProfileAdd} onPress={handlePress} aria-label="Share for Review">
      Share for Review
    </Button>
  )
})
